import 'normalize.css' // 重置样式
import './common.less' // 公共样式
import '../less/ico.less' // 图标字体
